// 'use strict';

import { createRef } from 'react'
import classNames from 'classnames'

export default class HiddenSide extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isOpen: false,
      loading: true,
      url: ''
    }
    this.hiddenSideContentRef = createRef(null)
    this.scrollButtonRef = createRef(null)
    this.hiddenSideRef = createRef(null)
  }

  componentDidMount () {
    this.contentElement = $(this.hiddenSideContentRef.current)

    window.hidden_side = {
      contentElement: this.contentElement,
      insertContent: (content) => {
        this.contentElement.html(content)
        setTimeout(() => {
          this.contentElement.trigger('content-inserted')
          ReactOnRails.reactOnRailsPageLoaded()
        }, 100)
      },
      close: this._close.bind(this),
      open: this._open.bind(this)
    }

    // Each instance gets a unique namespace so componentWillUnmount only removes
    // its own handler and does not affect other mounted HiddenSide instances.
    this._clickNamespace = `click.hidden-side-${Math.random().toString(36).slice(2)}`
    const _this = this
    $(document).on(this._clickNamespace, '[data-hidden-side-toggle]', function (e) {
      e.preventDefault()
      const url = $(this).attr('href')

      if (_this.state.isOpen && url === _this.state.url) {
        _this._close()
      } else {
        _this._open(url)
      }
    })

    // scroll button
    this.contentElement.on('content-inserted', () => {
      $(this.scrollButtonRef.current).fadeOut()
      this.contentElement.off('mousewheel')
      // show scroll button if content is too long
      this.hiddenSideHight = $(this.hiddenSideRef.current).innerHeight()
      this.contentElement.on('mousewheel', this.scrollHandler)
      $(this.contentElement.find('iframe').contents()).on('mousewheel', this.scrollHandler)
    })

    this.scrollHandler = () => {
      if (this.contentElement[0].getClientRects()[0].bottom > this.hiddenSideHight + 30 &&
        this.contentElement.innerHeight() > this.hiddenSideHight + 300) {
        $(this.scrollButtonRef.current).fadeIn()
      } else {
        $(this.scrollButtonRef.current).fadeOut()
      }
    }
  }

  render () {
    return (
      <span>
        <div id='hidden-side' className={this.state.isOpen ? 'open' : 'closed'} ref={this.hiddenSideRef} data-turbo='false'>
          <div className='hidden-side-close ti-close' onClick={this._close.bind(this)} />
          <div className={classNames({ loading: this.state.loading }, 'block')} ref={this.hiddenSideContentRef} />
        </div>
        <button className='hidden-side-scroll-down btn-info' ref={this.scrollButtonRef} onClick={this._scrollDown.bind(this)}>
          <i className='ti-arrow-down' />
          Scroll down
        </button>
      </span>
    )
  }

  componentWillUnmount () {
    $(document).off(this._clickNamespace)
  }

  _open (url) {
    this.setState({ loading: true, isOpen: false })
    setTimeout(() => this.setState({ isOpen: true, url }), 100)
    if (url) $.ajax({ url, dataType: 'script' }).done((data) => this.setState({ loading: false }))
    $('body').addClass('hidden-side-opened')
  }

  _close () {
    this.setState({ loading: true, isOpen: false })
    $('body').removeClass('hidden-side-opened')
    this.contentElement.empty()
    $(this.scrollButtonRef.current).hide()
  }

  _scrollDown () {
    $(this.hiddenSideRef.current).animate({ scrollTop: this.contentElement.innerHeight() })
    $(this.scrollButtonRef.current).fadeOut()
  }
}
